import { request } from "../../../backend";

/**
 * Logs into SaleSys using an MFA code. Assumes MFA token is set in cookies.
 */
export async function loginMfaCode(code: string) {
  await request(
    '/login-v1/mfa', 'post', { mfaCode: code }, null, { api: 'users', injectStatus: true }
  );
}